import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTranslation } from 'react-i18next';
import { Crown, Lock } from 'lucide-react';
import { Card, Button } from './ui';

const PremiumGate = ({ children, feature = '' }) => {
  const { user } = useAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const isPremium = user?.subscription_plan && user.subscription_plan !== 'free';

  if (isPremium) {
    return children;
  }

  return (
    <Card className="p-8 text-center border-primary/20">
      <div className="w-16 h-16 bg-primary/10 rounded-sm flex items-center justify-center mx-auto mb-4">
        <Lock className="w-8 h-8 text-primary" />
      </div>
      <h3 className="font-heading text-xl mb-2">
        {t('premium.locked', 'Premium Feature')}
      </h3>
      <p className="text-muted-foreground text-sm mb-6 max-w-md mx-auto">
        {feature || t('premium.upgradeDesc', 'Upgrade to Premium to unlock this feature and get unlimited access to all InkTrack tools.')}
      </p>
      <Button onClick={() => navigate('/pricing')} className="gap-2">
        <Crown className="w-4 h-4" />
        {t('premium.upgrade', 'Upgrade to Premium')}
      </Button>
    </Card>
  );
};

export default PremiumGate;
